module.exports = __webpack_public_path__ + "static/media/2.ecd21396.gif";